import Header from "./Header";

export default function BistOffline() {
	return <Header title="Offline" subtitle="Du scheinst offline zu sein." />;
}
